// The adjacent author name labels the comment; its picture is decorative.
export function buildCommentAvatar(profile, className = "comment-avatar") {
  const avatar = document.createElement("span")
  avatar.className = className
  avatar.setAttribute("aria-hidden", "true")

  const name = profile?.name?.trim() || "Unknown"
  const initials = profile?.initials?.trim() || name.split(/\s+/).map(part => Array.from(part)[0]).join("")
  avatar.textContent = Array.from(initials).slice(0, 2).join("").toUpperCase()

  if (profile?.avatar_url) {
    const image = document.createElement("img")
    image.alt = ""
    image.hidden = true
    image.addEventListener("load", () => {
      image.hidden = false
      avatar.replaceChildren(image)
    }, { once: true })
    image.addEventListener("error", () => image.remove(), { once: true })
    avatar.appendChild(image)
    image.src = profile.avatar_url
  }

  return avatar
}
